<div class="verification-banner" *ngIf="visible" role="status" aria-live="polite">
  <div class="verification-banner__content">
    <span class="verification-banner__icon" aria-hidden="true">✉</span>
    <span class="verification-banner__text">
      Please verify your email to unlock inviting teammates, upgrading, and connecting data sources.
    </span>
    <button
      type="button"
      class="verification-banner__action"
      [disabled]="sending || cooldownSec > 0"
      (click)="resend()">
      <ng-container *ngIf="!sending && cooldownSec === 0">Resend email</ng-container>
      <ng-container *ngIf="sending">Sending…</ng-container>
      <ng-container *ngIf="!sending && cooldownSec > 0">Resend in {{cooldownSec}}s</ng-container>
    </button>
    <button
      type="button"
      class="verification-banner__dismiss"
      aria-label="Dismiss"
      (click)="dismiss()">
      &times;
    </button>
  </div>
  <div class="verification-banner__message" *ngIf="message">{{message}}</div>
</div>
